import {GetFormattedProductData} from '@/models/ProductOverviewModel'
import {getProductOverview} from '@/services/ProductsService/ProductOverview/productOverview'
import {useQuery} from '@tanstack/react-query'
import {useMemo} from 'react'
import {useParams} from 'react-router-dom'

export const useProductOverview = () => {
  const {id} = useParams() // Extract id from URL parameters

  const {data, isLoading} = useQuery({
    queryKey: ['PRODUCT', id],
    queryFn: () => getProductOverview(`${id}`),
    enabled: !!id, // Only run the query if we have an ID
  })

  const formattedData = useMemo(() => (data ? GetFormattedProductData(data) : {}), [data])

  return {
    productOverviewData: formattedData,
    isLoading,
  }
}
